import gql from 'graphql-tag';

export const createShiftTurnover = gql`
  mutation createShiftTurnover($input: CreateShiftTurnoverInput) {
    createShiftTurnover(input: $input) {
      id
      status
      shiftDate
      incomingCompletedDate
      departingCompletedDate
      createdAt
      version
      updatedAt
      businessUnit {
        id
      }
      ShiftType {
        id
        name
      }
      AOR {
        id
        name
      }
      ShiftDetails {
        id
        incomingDepartingFlag
        Analyst {
          id
          firstName
          lastName
        }
        fitFlag
        scadaFlag
        additionalComments
        ShiftTurnoverItems {
          id
          turnoverFlag
          comments
          ShiftItem {
            id
            name
            sortOrder
          }
        }
        ShiftTurnoverMitigations {
          id
          turnoverFlag
          ShiftMitigation {
            id
            name
          }
        }
      }
    }
  }
`;
